import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
	styles: {
	  global: () => ({
		body: {
		  bg: "white",
		  color:"black"
		},
	  }),
	},
	useSystemColorMode: false,
	initialColorMode: 'light',
  });
export default theme